const pt = {
  home: {
    biometric_label: "VERIFICAÇÃO DE IDENTIDADE BIOMÉTRICA",
    title: "Pesquisa Inversa de Rostos",
    description:
      "Carregue um retrato de alta resolução para cruzar referências com arquivos digitais globais usando correspondência neural avançada.",
    drag_drop: "Arraste e solte sua imagem",
    file_formats: "Suporta RAW, JPEG ou PNG (Máx 15MB)",
    select_file: "SELECIONAR ARQUIVO DO SISTEMA",
    initiate_scan: "Iniciar Análise Forense",
    upload_hint: "CARREGUE UMA IMAGEM PARA CONTINUAR",
    uploading: "Enviando",
    searching: "Escaneando",
    result_title: "Resultados",
    drop_here: "Solte a imagem aqui...",
    billion_faces: "Compare com mais de 1 bilhão de rostos na internet",
    login_to_search: "Entrar para pesquisar",
    login_required: "Faça login ou crie uma conta para usar este app",
    not_enough_tokens: "Tokens insuficientes",
    please_wait: "Por favor, aguarde alguns minutos",
    leave_confirmation:
      "Há um processo em andamento. Tem certeza de que quer sair?",
  },
  sources: {
    section_title: "Fontes que Pesquisamos",
    social_media: {
      name: "Redes Sociais",
      description:
        "Referências cruzadas nas principais redes sociais e perfis públicos.",
    },
    web: {
      name: "Web",
      description:
        "Varre a web aberta em busca de dados de rostos disponíveis publicamente.",
    },
    scammers: {
      name: "Golpistas",
      description:
        "Compara com bancos de dados de identidade de golpistas conhecidos.",
    },
    sexual_offenders: {
      name: "Ofensores Sexuais",
      description:
        "Referências cruzadas com registros públicos de ofensores registrados.",
    },
    videos: {
      name: "Vídeos",
      description: "Extrai e compara rostos de plataformas de vídeo públicas.",
    },
    police_photos: {
      name: "Fotos Policiais",
      description:
        "Compara com bancos de dados de registros policiais disponíveis publicamente.",
    },
    news_and_blogs: {
      name: "Notícias e Blogs",
      description:
        "Pesquisa em arquivos de notícias, conteúdo editorial e blogs.",
    },
  },
  header: {
    scan: "ESCANEAR",
    history: "HISTÓRICO",
    pricing: "PREÇOS",
    account: "CONTA",
    logout: "SAIR",
    app_name: "Digital Forensicist",
  },
  footer: {
    copyright:
      "© 2024 Digital Forensicist. Todos os direitos reservados. Verificação de Identidade de Precisão.",
    privacy: "Política de Privacidade",
    terms: "Termos de Serviço",
    docs: "Documentação",
    support: "Suporte",
  },
  common: {
    loading: "Carregando...",
    error: "Erro",
    cancel: "Cancelar",
    back: "Voltar",
  },
  errors: {
    upload_failed: "Falha no envio. Tente novamente.",
    not_enough_tokens:
      "Você não tem tokens suficientes para realizar esta pesquisa.",
  },
  login: {
    disclaimer:
      "Você precisa de uma conta para usar este app. Não enviamos spam nem compartilhamos seu e-mail. Sugerimos entrar com a Apple para manter sua privacidade.",
  },
  results: {
    input_source: "FONTE DE ENTRADA",
    match_thumbnail: "Miniatura da correspondência",
    extraction_id: "ID DE EXTRAÇÃO",
    scan_analysis: "Análise de digitalização",
    scan_description:
      "Pesquisa biométrica reversa concluída. Encontradas %{count} correspondências potenciais em registros públicos e índices sociais.",
    col_identity_map: "MAPA DE IDENTIDADE",
    col_verification_path: "CAMINHO DE VERIFICAÇÃO",
    col_bio_match_score: "PONTUAÇÃO BIO",
    col_action: "AÇÃO",
    export_pdf: "Exportar PDF",
    exporting: "Gerando...",
    verified: "VERIFICADO",
    details: "DETALHES",
    details_tooltip: "Executar comparação facial precisa",
    details_loading: "Comparando...",
    copied: "Copiado!",
    copy_url: "Copiar URL",
    displaying: "Exibindo %{count} de %{total} detecções",
  },
};

export default pt;
